<template>
  <!-- eslint-disable -->
<v-container fluid>
<v-slide-y-transition mode="out-in">
  <div>
    <v-speed-dial v-model="fab" right top fixed direction="bottom" transition="slide-y-reverse-transition">
      <template v-slot:activator>
        <v-btn class="refresh-btn" v-model="fab" color="blue darken-2" dark fab>
          <v-icon v-if="fab">close</v-icon>
          <v-icon v-else>account_circle</v-icon>
        </v-btn>
      </template>
      <v-btn fab dark small class="add-user-btn" color="indigo" @click="add()">
        <v-icon>add</v-icon>
      </v-btn>
      <v-btn fab class="refresh-users-btn" dark small color="red" @click="loadUsers()">
        <v-icon>refresh</v-icon>
      </v-btn>
    </v-speed-dial>
    <v-layout row wrap class="ma-0 pa-0">
      <v-flex class="ma-0 pa-0">
        <v-text-field class="user-filter" slot="search" prepend-icon="search" :append-icon="search == null || search.length === 0 ? '' : 'clear'" @click:append="() => (search = null)" label="Search" single-line hide-details v-model="search"></v-text-field>
      </v-flex>
      <v-flex class="ma-0 pa-0">
        <v-select class="client-filter-select" content-class="client-filter-list" :items="users" v-model="selectedClientId" prepend-icon="filter_list" item-text="ClientName" item-value="ClientId" label="Filter by Client" single-line :append-icon="selectedClientId == null || selectedClientId.length === 0 ? '' : 'clear'" @click:append="() => clearFilter()"></v-select>
      </v-flex>
      <v-flex class="ma-0 pa-0" v-if="selectedClientId">
        <v-select class="client-location-filter-select" content-class="client-location-filter-list" :items="getUniqueLocations()" v-model="selectedLocationId" prepend-icon="filter_list" item-text="Name" item-value="Id" label="Filter by Location" single-line :append-icon="selectedLocationId == null || selectedLocationId.length === 0 ? '' : 'clear'" @click:append="() => (selectedLocationId = null)"></v-select>
      </v-flex>
    </v-layout>
    <v-data-table :mobile-breakpoint="0" class="users-data-table" :items="filteredUsers" :items-per-page.sync="rowsPerPage" :footer-props="{'items-per-page-options': [50,100,200]}" item-key="UserName" :headers="headers" :loading="loading">
      <template slot="no-data">
        <div v-if="loading" class="text-xs-center users-loading">
          Loading Users. . .
        </div>
        <div v-else class="text-xs-center no-users">
          No Users.
        </div>
      </template>
      <template v-slot:item="{ item }">
        <tr class="user-row" v-on:mouseenter="userHover(item, true)" v-on:mouseleave="userHover(item, false)" @click="edit(item)">
          <td>
            <v-list-item-action avatar style="float: left">
              <v-avatar class="user-avatar" :class="getColor(item.ClientId)" v-if="!item.hover">
              <span class="white--text headline">{{item.UserName.match(/\b(\w)/g)[0].toUpperCase()}}</span>
              </v-avatar>
              <div v-else class="edit-icon" style="position: relative; top: 5px; left: 15px;">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" @click="edit(item)" small>mode_edit</v-icon>
                  </template>
                  <span>Edit</span>
                </v-tooltip>
              </div>
            </v-list-item-action>
            <div style="padding: 20px 0 20px 75px;"><b>{{ item.UserName }}</b></div>
          </td>
          <td class="hidden-sm-and-down">
            {{ item.Email }}
          </td>
          <td>
            {{item.ClientName}}
          </td>
          <td class="hidden-sm-and-down">
            {{ item.PhoneNumber }}
          </td>
        </tr>
      </template>
    </v-data-table>
    <user-dialog></user-dialog>
  </div>
  </v-slide-y-transition>
  </v-container>
<!-- eslint-enable -->
</template>
<script>
import usersModule, { USERS_NAMESPACE } from "./store/userStore";
import { mapGetters } from "vuex";
import UserDialog from "./UserDialog";
import UserMixin from "@/mixins/UserMixin.js";
export default {
  name: "Users",
  components: {
    "user-dialog": UserDialog
  },
  mixins: [UserMixin],
  data() {
    return {
      headers: [
        { text: "User Name", sortable: true, align: "left", value: "UserName" },
        {
          text: "Email",
          sortable: true,
          align: "left",
          value: "Email",
          class: "hidden-sm-and-down"
        },
        {
          text: "Client",
          sortable: true,
          align: "left",
          value: "ClientName"
        },
        {
          text: "Phone",
          sortable: false,
          align: "left",
          class: "hidden-sm-and-down"
        }
      ],
      rowsPerPage: 100,
      selectedClientId: null,
      selectedLocationId: null
    };
  },
  computed: {
    ...mapGetters(USERS_NAMESPACE, ["users", "loading", "clients"]),
    filteredUsers() {
      if (this.search) {
        return this.users.filter(x =>
          x.UserName.toLowerCase().includes(this.search.toLowerCase())
        );
      }
      if (this.selectedClientId) {
        if (this.selectedLocationId) {
          return this.users.filter(
            x =>
              x.ClientId === this.selectedClientId &&
              x.UserLocations.find(
                l => l.LocationId === this.selectedLocationId
              ).Selected === true
          );
        }
        return this.users.filter(x => x.ClientId === this.selectedClientId);
      }
      return this.users;
    }
  },
  created: /* istanbul ignore next */ function() {
    this.USER_MIXIN_NAMESPACE = USERS_NAMESPACE;
    this.$registerVuexModule(USERS_NAMESPACE, usersModule);
    this.$isInRole([this.$roleDefs.ADMIN, this.$roleDefs.CLIENT_ADMIN]).then(
      res => {
        if (res) {
          this.loadUsers();
          this.loadClients();
        } else this.$goHome();
      }
    );
  },
  methods: {
    clearFilter() {
      this.selectedClientId = null;
      this.selectedLocationId = null;
    },
    getUniqueLocations() {
      if (this.selectedClientId) {
        let locArray = [];
        this.users.forEach(x => {
          if (x.UserLocations && x.ClientId === this.selectedClientId) {
            /* istanbul ignore else */
            if (x.UserLocations)
              x.UserLocations.forEach(l => {
                locArray.push({
                  Id: l.LocationId,
                  Name: l.Name,
                  ClientId: x.ClientId
                });
              });
          }
        });
        return _.uniqWith(locArray, _.isEqual);
      }
      return [];
    }
  }
};
</script>
